import TiktokIcon from "@src/app/assets/icons/tiktok.svg?react";
import YoutubeIcon from "@src/app/assets/icons/youtube.svg?react";
import { ThemeEnum } from "@src/app/components//ThemeProvider/ThemeProvider";
import PageArticleList from "@src/app/components/ArticleList/PageArticleList";
import { createMetaTags } from "@src/app/components/MetaTags/MetaTags";
import SectionContainer from "@src/app/components/SectionContainer";
import { SocialShareLinks } from "@src/app/components/SocialShare/SocialShare";
import TiktokCard from "@src/app/components/TiktokCard/TiktokCard";
import VideoPlayerWithWidgets from "@src/app/components/VideoPlayerWithWidgets/VideoPlayerWithWidgets";
import VideoPlaylistCard from "@src/app/components/VideoPlaylistCard/VideoPlaylistCard";
import { useRouteResponse } from "@src/app/hooks/useRouteResponse";
import { isThisUrlFrom } from "@src/app/utils/tools";
import type { LinksFunction, LoaderFunction } from "react-router";

import { fetchSectionPageData } from "./Section.server";

export const loader: LoaderFunction = (args) =>
  fetchSectionPageData({ ...args, params: { level1: "videos" } });

export const meta = () =>
  createMetaTags({
    title: "视频 - 用看的，快速吸收重点资讯 - 红蚂蚁",
    description:
      "视频 - 用视频轻松看懂世界大小事，资讯一目了然。《红蚂蚁》以生动的笔调撰写独立观点，以新颖的手法呈现新闻，让读者被咬得直呼过瘾。",
    canonical: "https://www.redants.sg/videos",
  });

export const links: LinksFunction = () => {
  return [...SocialShareLinks()];
};

export default function VideoCategoryPage() {
  const res = useRouteResponse("videoPage");

  console.log(res, "VideoCategory");

  const videoPlaylist = res.videoPlaylist?.filter(
    (item) =>
      item.youtubeUrl &&
      item.youtubeUrl.length > 0 &&
      isThisUrlFrom(item.youtubeUrl, "youtube.com"),
  );

  return (
    <div className="bg-inverse lg:px-6">
      {/* Video Playlist */}
      {videoPlaylist && videoPlaylist.length > 0 && (
        <div className="mx-auto max-w-[1200px]">
          <VideoPlayerWithWidgets articles={videoPlaylist} />
        </div>
      )}

      {/* Youtube Playlist */}
      {res.youtubePlaylists && res.youtubePlaylists.length > 0 && (
        <SectionContainer
          icon={<YoutubeIcon color="#E11E27" />}
          theme="dark"
          title="访问红蚂蚁YouTube"
          more="https://www.youtube.com/@RedAntsSG/playlists"
          newTab
        >
          <div className="flex gap-6 overflow-auto bg-inverse px-3 py-4 lg:grid lg:grid-cols-4">
            {res.youtubePlaylists.map((playlist) => (
              <VideoPlaylistCard
                key={playlist.id}
                id={playlist.id}
                thumbnailUrl={playlist.thumbnail.url}
                link={`https://www.youtube.com/playlist?list=${playlist.id}`}
                title={playlist.title}
                numberOfVideo={playlist.itemCount}
              />
            ))}
          </div>
        </SectionContainer>
      )}

      {/* Tiktok Videos */}
      {res.tiktokPosts && res.tiktokPosts.length > 0 && (
        <SectionContainer
          icon={<TiktokIcon />}
          theme="dark"
          title="访问红蚂蚁TikTok"
          more="https://www.tiktok.com/@redants.sg"
          newTab
        >
          <div className="flex gap-6 overflow-auto bg-inverse px-3 py-4 lg:grid lg:grid-cols-4">
            {res.tiktokPosts.map((tiktokPost, index) => (
              <TiktokCard
                key={index}
                videoSrc={tiktokPost}
                videoTitle="tiktok"
              />
            ))}
          </div>
        </SectionContainer>
      )}

      {/* Articles */}
      <PageArticleList
        initialData={res.articles || []}
        theme={ThemeEnum.dark}
        title="所有视频"
        requestPath={"/page/videos"}
        requestQuery={{
          excludeIds: res.videoPlaylist?.map((i) => i.id).join(",") || "",
        }}
        showSubHeader={false}
      />
    </div>
  );
}
